import { render } from "./AnnounceForm.vue?vue&type=template&id=5919294b&scoped=true"
import script from "./AnnounceForm.vue?vue&type=script&lang=js"
export * from "./AnnounceForm.vue?vue&type=script&lang=js"

import "./AnnounceForm.vue?vue&type=style&index=0&id=5919294b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5919294b"]])

export default __exports__